import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fbf0eb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "stake__title" }, "Stake DOT and earn rewards", -1))
const _hoisted_2 = { class: "stake__block stake__block--start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " You can earn rewards by bonding assets and then nominating your validators. ", -1))
const _hoisted_4 = { class: "stake__calculate" }
const _hoisted_5 = { class: "stake__calculate-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Calculate investments", -1))
const _hoisted_7 = { class: "row justify-content-start" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "stake__calculate-items" }
const _hoisted_11 = { class: "stake__calculate-block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Estimated Returns", -1))
const _hoisted_13 = { class: "stake__calculate-block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Estimated Yield", -1))
const _hoisted_15 = { class: "stake__lock" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Lock rewards for compounding?", -1))

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import ButtonsBlock from "@/components/buttons-block/index.vue";
import BaseButton from "@/components/base-button/index.vue";
import StakeStartImage from "@/icons/stake/stake-start-image.vue";
import MoreLink from "@/components/more-link/index.vue";
import Switch from "@/components/switch/index.vue";
import InfoTooltip from "@/components/info-tooltip/index.vue";
import BaseSelect from "@/components/base-select/index.vue";
import { BaseSelectItem } from "@/types/base-select";
import StakeAmountInput from "./stake-amount-input.vue";
import { useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { apiPromise, nativeToken, stakingWizardOptions } from "@/stores";
import { useGetNativeBalances } from "@/libs/balances";
import { useGetNativePrice } from "@/libs/prices";
import { periodOptions, periodToNumberOfDays } from "@/types/staking";
import { getLastEraReward } from "@/utils/staking";

const rewardsInfo =
  "If you choose not to lock your rewards, then your newly minted rewards will be transferrable by default. However, this would mean lower earnings over longer period of time.";
const periodInfo =
  "Time period is only used for estimating returns. It doesn’t affect the unbonding period of approximately 28 days.";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-intro',
  setup(__props) {

const router = useRouter();

const amount = ref<number>(0);
const period = ref<BaseSelectItem>(periodOptions[0]);
const lastEraReward = ref<number>(0);
const isCompounding = ref<boolean>(true);

onMounted(async () => {
  useGetNativeBalances();
  useGetNativePrice();
  updateRewardCalculation();
  loadPreviousStakingOptions();
});

const estimatedYield = computed(() => {
  const numberOfDays = periodToNumberOfDays(period.value.id);

  return isCompounding.value
    ? Math.pow(1 + lastEraReward.value, numberOfDays) - 1
    : lastEraReward.value * numberOfDays;
});

const estimatedReturn = computed(() => {
  return estimatedYield.value * amount.value;
});

const estimatedReturnUsd = computed(() => {
  return nativeToken.value.price.times(estimatedReturn.value).toNumber();
});

const loadPreviousStakingOptions = () => {
  isCompounding.value = stakingWizardOptions.value.isCompounding;
  if (stakingWizardOptions.value.amount) {
    amount.value = stakingWizardOptions.value.amount;
  }
  const searchPeriod = periodOptions.find(
    (item) => item.id === stakingWizardOptions.value?.period
  );
  if (searchPeriod) {
    period.value = searchPeriod;
  }
};

const updateRewardCalculation = async () => {
  const api = await apiPromise.value;
  lastEraReward.value = await getLastEraReward(api);
};

const updateCompounding = (newValue: boolean) => {
  isCompounding.value = newValue;
};

const inputAmount = (newVal: string) => {
  amount.value = Number(newVal);
};

const nextAction = () => {
  stakingWizardOptions.value = {
    isCompounding: isCompounding.value,
    period: period.value.id,
    amount: amount.value,
  };
  router.push({
    name: "stake-enter-amount",
  });
};

const moreAction = () => {
  console.log("moreAction");
};

const selectPeriod = (item: BaseSelectItem) => {
  period.value = item;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WhiteWrapper, { class: "stake__wrap" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(StakeStartImage),
        _hoisted_3,
        _createVNode(MoreLink, {
          title: "Learn more about how it works",
          action: moreAction
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(InfoTooltip, { text: periodInfo }),
          _createVNode(BaseSelect, {
            options: _unref(periodOptions),
            selected: period.value,
            "onToggle:select": selectPeriod
          }, null, 8, ["options", "selected"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(StakeAmountInput, {
              token: _unref(nativeToken),
              value: String(amount.value),
              "onUpdate:amount": inputAmount
            }, null, 8, ["token", "value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("h5", null, [
                  _createTextVNode(_toDisplayString(estimatedReturn.value
                    ? _ctx.$filters.cryptoCurrencyFormat(estimatedReturn.value)
                    : "--"), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(nativeToken).symbol), 1)
                ]),
                _createElementVNode("p", null, "~" + _toDisplayString(_ctx.$filters.currencyFormat(estimatedReturnUsd.value, "USD")), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("h5", null, _toDisplayString(estimatedYield.value
                    ? _ctx.$filters.cryptoCurrencyFormat(estimatedYield.value * 100)
                    : "--") + " % ", 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(ButtonsBlock, { "is-space": true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(Switch, {
              "is-checked": isCompounding.value,
              "onUpdate:check": updateCompounding
            }, null, 8, ["is-checked"]),
            _hoisted_16,
            _createVNode(InfoTooltip, { text: rewardsInfo })
          ]),
          _createVNode(BaseButton, {
            title: "Start staking",
            action: nextAction,
            send: true
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})